import React from 'react'
import {graphql} from 'gatsby'
import {
  mapEdgesToNodes,
  filterOutDocsWithoutSlugs,
  filterOutDocsPublishedInTheFuture
} from '../lib/helpers'
// import BlogPostPreviewList from '../components/blog-post-preview-list'
import GraphQLErrorList from '../components/graphql-error-list'
import SEO from '../components/seo'
import Layout from '../containers/layout'

import Hero from '../components/hp-sections/hero'
// import Transportation from '../components/hp-sections/transportation'
import About from '../components/hp-sections/about-section'
import Swim from '../components/hp-sections/swim-lessons'
import Programs from '../components/hp-sections/programs'
// import LocationGmap from '../components/hp-sections/location-gmap'
import Testimonials from '../components/hp-sections/testimonials'
import LatestNews from '../components/hp-sections/latest-news'

const IndexPage = props => {
  const {data, errors} = props

  if (errors) {
    return (
      <Layout>
        <GraphQLErrorList errors={errors} />
      </Layout>
    )
  }

  const site = (data || {}).site
  const ogImage = (data || {}).ogImage
  const postNodes = (data || {}).posts
    ? mapEdgesToNodes(data.posts)
      .filter(filterOutDocsWithoutSlugs)
      .filter(filterOutDocsPublishedInTheFuture)
    : []

  if (!site) {
    throw new Error(
      'Missing "Site settings". Open the studio at http://localhost:3333 and add some content to "Site settings" and restart the development server.'
    )
  }
  return (
    <Layout>
      <SEO
        title={site.title}
        description={site.description}
        image={ogImage.headerImage}
      />
      <Hero />
      <About />
      <Programs />
      <Swim />
      {/* <LocationGmap /> */}
      <Testimonials />
      <LatestNews posts={postNodes} />

      {/* {postNodes && (
          <BlogPostPreviewList
            title='Latest blog posts'
            nodes={postNodes}
            browseMoreHref='/archive/'
          />
        )} */}
    </Layout>
  )
}

export default IndexPage

export const query = graphql`
  
  query IndexPageQuery {
    site: sanitySiteSettings(_id: { regex: "/(drafts.|)siteSettings/" }) {
      title
      description
    }
    ogImage: sanityPage(_id: { regex: "/(drafts.|)letterFromTheDirector/" }) {
      headerImage {
        ...SanityImageMeta
        alt
      }
    }
    posts: allSanityPost(
      limit: 6
      sort: { fields: [publishedAt], order: DESC }
      filter: { slug: { current: { ne: null } }, publishedAt: { ne: null } }
    ) {
      edges {
        node {
          id
          publishedAt
          mainImage {
            asset {
              fluid(maxWidth: 700) {
                ...GatsbySanityImageFluid
              }
            }
            alt
          }
          title
          _rawExcerpt
          slug {
            current
          }
        }
      }
    }
  }
`
